export default {
  AbsoluteIndependent: 3,
  NoFinancialAutonomy: 6,
  RelativeIndependent: 2,
  Depedent: 1,
  NormalExpenditureAndInvest: 4,
  NormalExpenditure: 5
};
